import { useFormContext } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Card, CardContent } from '@/components/ui/card';
import { paymentMethods } from '@/lib/validation';
import { CreditCard, Smartphone, Banknote, Store, Truck, AlertCircle, Package } from 'lucide-react';

const paymentIcons = {
  credit_card: CreditCard,
  linepay: Smartphone,
  atm: Banknote,
  cvs: Store,
  cvs_pickup_cod: Package,
  cvs_pickup_prepaid: Package,
  cod: Truck,
};

export function PaymentMethodSelector() {
  const {
    register,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();

  const selectedPayment = watch('payment_method');

  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold">付款方式</h3>
      
      {/* 改用原生 radio input，不使用 RadioGroup 避免無窮迴圈 */}
      <div className="space-y-3">
        {paymentMethods.map((method) => {
          const Icon = paymentIcons[method.value];
          const isSelected = selectedPayment === method.value;
          
          return (
            <Card
              key={method.value}
              className={`cursor-pointer transition-all relative ${
                isSelected
                  ? 'border-blue-600 ring-2 ring-blue-200 bg-blue-50'
                  : 'hover:border-gray-400'
              }`}
              onClick={() => setValue('payment_method', method.value, { shouldValidate: true })}
            >
              <CardContent className="p-4">
                <div className="flex items-center gap-3">
                  {/* 使用原生 Radio Input */}
                  <input
                    type="radio"
                    id={method.value}
                    value={method.value}
                    {...register('payment_method')}
                    className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500 accent-blue-600 cursor-pointer"
                  />
                  
                  <Icon className={`h-5 w-5 ${isSelected ? 'text-blue-600' : 'text-gray-600'}`} />
                  
                  <div className="flex-1">
                    <Label
                      htmlFor={method.value}
                      className={`font-medium cursor-pointer block ${
                        isSelected ? 'text-blue-900' : 'text-gray-900'
                      }`}
                    >
                      {method.label}
                    </Label>
                    <p className={`text-sm ${isSelected ? 'text-blue-700' : 'text-gray-500'}`}>
                      {method.description}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {errors.payment_method && (
        <p className="text-sm text-red-600 flex items-center gap-1">
          <AlertCircle className="h-3 w-3" />
          {errors.payment_method.message}
        </p>
      )}

      {/* 付款方式說明 */}
              {selectedPayment && (
                <Card className="bg-blue-50 border-blue-200">
                  <CardContent className="p-4">
                    <p className="text-sm text-blue-800">
                      {selectedPayment === 'credit_card' && '選擇信用卡付款後，將導向安全付款頁面。'}
                      {selectedPayment === 'linepay' && '選擇 LINE Pay 後，將開啟 LINE Pay 付款流程。'}
                      {selectedPayment === 'atm' && 'ATM 轉帳：訂單成立後顯示銀行帳號，請於 3 天內完成匯款。匯款後請通知客服確認。'}
                      {selectedPayment === 'cvs' && '超商代碼繳費：系統將提供繳費代碼，可至 7-11、全家、萊爾富、OK 繳費。'}
                      {selectedPayment === 'cvs_pickup_cod' && '超商取貨付款：商品寄送至指定超商門市，取貨時現場付款（需運費 $60 + 手續費 $60）。'}
                      {selectedPayment === 'cvs_pickup_prepaid' && '超商取貨（先付款）：先完成線上付款，商品寄送至超商門市後再取貨（需運費 $60）。'}
                      {selectedPayment === 'cod' && '宅配貨到付款：宅配送達時再付款給物流人員（需額外收取 60 元手續費）。'}
                    </p>
                  </CardContent>
                </Card>
              )}
    </div>
  );
}
